<template>
  <div class="contentBox"  v-loading="loading" :element-loading-text="loadTxt" :class="device=='mobile'?'mobileBox':''">
    <button class="btn btn-back" @click="goBack"></button>
    <web ref="web" class="webBox"></web>
    <p class="title">习题{{dataObj.num}}</p>
    <div class="detail">
      <div class="detail-item">
        <div class="detail-txt">
          <div class="left">
            <p class="book-name" v-if="listData.book_title">{{listData.book_title}}</p>
            <p class="txt" v-html="listData.content"></p>
          </div>
          <div class="right">
            <div class="right-item" v-for="(item,index) in listData.topics" :key="index">
              <p class="topic-title">{{(index+1)}}. {{item.topic}}</p>
              <textarea name="" id="" v-model="item.my_answer"></textarea>
              <div class="answer" v-if="item.status == 1">
                <div class="answer-title">
                  你的回答: 
                  <img v-if="topicRtid==item.rtid" src="./../../src/assets/images/answer-loading.gif" alt="" class="answer-loading">
                  <div v-else>
                    <span v-if="listData.type==3">{{item.is_true==0?'未知':item.is_true==1?'回答满分!':'有待提升！'}}</span>
                    <span v-else>{{item.is_true==0?'未知':item.is_true==1?'回答正确!':'有待提升！'}}</span>
                    <button class="btn btn-refresh" @click="newAnswer(item)">点击刷新</button>
                  </div>
                </div>
                <p class="answer-txt">正确答案: <span v-html="item.answer"></span></p>
                <div class="aiBox" style="margin-top:20px;">
                  <div class="ai-title">
                    AI点评:
                    <button class="btn btn-refresh" @click="newComment(item)">点击刷新</button>
                  </div>
                  <div class="ai-txt" v-if="error_analysis_type">
                    <img src="./../../src/assets/images/ai-loading.gif" alt="">
                  </div>
                  <div class="ai-txt" v-else>{{item.ai_comment}}</div>
                </div>
              </div>
            </div>
            <button class="btn btn-sub" v-if="listData.status == 0" @click="btnSub">{{btnTxt}}</button>
            <div class="" v-if="listData.status==1&&listData.type==1">
              <div class="aiBox" v-if="listData.is_true==0">
                <p class="ai-title">{{listData.type==1?'AI错因分析':'AI点评'}}:</p>
                <div class="ai-txt" v-if="error_analysis_type">
                  <img src="./../../src/assets/images/ai-loading.gif" alt="">
                </div>
                <div class="ai-txt" v-else>{{listData.ai_error_analysis}}</div>
              </div>
              <div class="aiBox">
                <p class="ai-title">AI习题讲解:</p>
                <div class="ai-txt">{{listData.explain?listData.explain:'暂无'}}</div>
              </div>
              <button class="btn btn-sub" v-if="listData.type==1" @click="detailSub">{{listData.is_true==1?'下一题':'去复盘'}}</button>
              <button class="btn btn-sub" v-else @click="nextTopic">下一题</button>
              <button class="btn btn-sub" @click="goAgain">再做一次</button>
            </div>
            <div class="" v-if="listData.status==1&&listData.type!=1">
              <div class="aiBox" v-if="listData.is_comp_comment == 1&&listData.ai_error_analysis">
                <div class="ai-title">
                  AI综合点评:
                  <button class="btn btn-refresh" @click="newComprehensiveReview(item)">点击刷新</button>
                </div>
                <div class="ai-txt">{{listData.ai_error_analysis}}</div>
              </div>
              <button class="btn btn-sub" v-if="listData.type==1" @click="detailSub">{{listData.is_true==1?'下一题':'去复盘'}}</button>
              <button class="btn btn-sub" v-else @click="nextTopic">下一题</button>
              <button class="btn btn-sub" @click="goAgain">再做一次</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getReadTopicDetail , addReadTopicAnswer ,addReadSmallTopicComment,addReadTopicComment ,addReadTopicCompComment,refreshAiErrorTopic,refreshTopicJudge } from "@/assets/js/api";
import web from './../components/comment/web.vue';
export default {
  name: "login",
  data() {
    return {
      token:'',
      dataObj:{},
      listData:[],
      loading:false,
      loadTxt:'',
      topicRtid:'',
      error_analysis_type:false,
      device:'',
      btnTxt:'提交答案'
    };
  },
  components: {
    web
  },
  mounted(){
    document.title = '练习题'
    var userData = JSON.parse(localStorage.getItem('identityData'));
    this.token = userData.apiToken;
    this.dataObj = {
      rmid:this.$route.query.rmid,
      rpid:this.$route.query.rpid,
      num:this.$route.query.num,
    }
    this.getDetail();
    this.device = this.$refs.web.device;
    if(this.device == 'mobile'){
      this.$refs.web.font_resize();
    }
  },
  methods: {
    async getDetail(){
      var that = this;
      try {
        const response = await getReadTopicDetail({rmid:this.dataObj.rmid,rpid:this.dataObj.rpid},this.token);
        if(response.code == 200){
          that.listData = response.data;
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      }
    },

    async btnSub(){
      var that = this;
  
      // 防止重复提交
      if (this.btnTxt == '请稍后') {
        return;
      }

      try {
        // 1. 检查是否有未填写的答案
        for (let index = 0; index < that.listData.topics.length; index++) {
          const item = that.listData.topics[index];
          if (!item.my_answer || item.my_answer.trim() === '') {
            that.$message('题目' + (index + 1) + '答案还未填写');
            return;
          }
        }

        // 2. 设置提交状态
        this.btnTxt = '请稍后';
        this.loading = true;
        this.loadTxt = '提交中...';

        // 3. 串行处理每个题目
        for (let index = 0; index < that.listData.topics.length; index++) {
          const item = that.listData.topics[index];
          
          // 3.1 先调用 addReadTopicAnswer 提交答案
          const answerObj = {
            rpid: that.dataObj.rpid,
            rmid: that.dataObj.rmid,
            rtid: item.rtid, 
            my_answer: item.my_answer,
            // lid:item.lid
          };
          
          try {
            const answerResponse = await addReadTopicAnswer(answerObj, this.token);
            if (answerResponse.code === 200) {
              // 更新题目判分结果
              that.listData.topics[index].is_true = answerResponse.data.ai_judge;
              that.listData.topics[index].lid = answerResponse.data.lid;
              console.log(`题目${index + 1}答案提交成功`);
            } else {
              that.$message(`题目${index + 1}提交失败：` + answerResponse.msg);
            }
          } catch (error) {
            console.error(`题目${index + 1}答案提交错误:`, error);
            that.$message(`题目${index + 1}提交失败`);
          }

          // 3.2 再调用 addReadSmallTopicComment 获取小题评论
          const commentObj = {
            rpid: that.dataObj.rpid,
            rmid: that.dataObj.rmid,
            rtid: item.rtid,
            lid: item.lid
          };
          try {
            const commentResponse = await addReadSmallTopicComment(commentObj, this.token);
            if (commentResponse.code === 200) {
              console.log(`题目${index + 1}评论获取成功`);
            } else {
              that.$message(`题目${index + 1}评论获取失败：` + commentResponse.msg);
            }
          } catch (error) {
            console.error(`题目${index + 1}评论获取错误:`, error);
          }
        }

        // 4. 所有题目处理完成后，获取整体评论
        await that.getComment();
        
      } catch (error) {
        console.error('提交过程发生错误:', error);
        that.$message(error.message || '提交过程中发生错误');
      } finally {
        // 5. 恢复提交状态
        this.btnTxt = '提交答案';
        this.loading = false;
      }
    },

    async getTopicComment(e,i){
      var that = this;
      var obj = {
        rpid:this.dataObj.rpid,
        rmid:this.dataObj.rmid,
        rtid:e.rtid,
        lid:e.lid
      }
      this.btnTxt = '请稍后';
      this.loading = true;
      try {
        const response = await addReadSmallTopicComment(obj,this.token);
        if(response.code == 200){
          // that.listData.topics[i].is_true = response.data.ai_judge;
          // console.log(i+1 , that.listData.topics.length)
          // if(i+1 == that.listData.topics.length){
          //   that.getComment();
          // }
        } else {
          that.$message(response.msg);
          that.loading = false;
        }
      } catch (error) {
        that.$message(error);
        that.loading = false;
      }
    },

    async answerSub(e,i){
      var that = this;
      var obj = {
        rpid:this.dataObj.rpid,
        rmid:this.dataObj.rmid,
        rtid:e.rtid,
        my_answer:e.my_answer
      }
      this.btnTxt = '请稍后';
      this.loading = true;
      try {
        const response = await addReadTopicAnswer(obj,this.token);
        if(response.code == 200){
          that.listData.topics[i].is_true = response.data.ai_judge;
          // console.log(i+1 , that.listData.topics.length)
          // if(i+1 == that.listData.topics.length){
          //   that.getComment();
          // }
        } else {
          that.$message(response.msg);
          that.loading = false;
        }
      } catch (error) {
        that.$message(error);
        that.loading = false;
      }
    },


    async getComment(){
      var that = this;
      var obj = {
        rpid:this.dataObj.rpid,
        rmid:this.dataObj.rmid,
      }
      this.loadTxt = 'ai生成中...'
      try {
        const response = await addReadTopicCompComment(obj,this.token);
        if(response.code == 200){
          that.listData.ai_error_analysis = response.data.ai_error_analysis;
          that.listData.status = 1;
          that.btnTxt = '提交答案'
        } else {
          that.$message(response.msg);
        };
        that.loading = false;
        that.getDetail();
      } catch (error) {
        that.$message(error);
        that.loading = false;
      }
      
    },

    async newAnswer(e){
      var that = this;
      // this.error_analysis_type = true;
      var obj = {
        rmid:that.dataObj.rmid,
        rpid:that.dataObj.rpid,
        rtid:e.rtid,
        my_answer:e.my_answer,
        lid:e.lid

      }
      this.topicRtid = e.rtid;
      try {
        const response = await addReadTopicAnswer(obj,this.token);
        if(response.code == 200){
          e.is_true = response.data.ai_judge;
          // that.listData.status = 1;
          that.topicRtid = '';
          // that.error_analysis_type = false;
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      }
    },

    async newComment(e){
      var that = this;
      this.error_analysis_type = true;
      var obj = {
        rmid:that.dataObj.rmid,
        rpid:that.dataObj.rpid,
        rtid:e.rtid,
        lid:e.lid,
      }
      try {
        const response = await addReadSmallTopicComment(obj,this.token);
        if(response.code == 200){
          e.ai_comment = response.data.ai_comment;
          that.error_analysis_type = false;
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      }
    },

    async newComprehensiveReview(e){
      var that = this;
      this.loading = true;
      this.loadTxt = '生成90%，请稍后';
      var obj = {
        rmid:that.dataObj.rmid,
        rpid:that.dataObj.rpid,
      }
      try {
        const response = await addReadTopicCompComment(obj,this.token);
        if(response.code == 200){
          that.listData.ai_error_analysis = response.data.ai_error_analysis;
        } else {
          that.$message(response.msg);
        }
        that.loading = false;
        that.loadTxt = '';
      } catch (error) {
        that.$message(error);
        that.loading = false;
        that.loadTxt = '';
      }
    },

    detailSub(){
      if(this.listData.is_true == 1){
        this.$router.push('/exam?rmid='+this.dataObj.rmid)
      } else {
        this.$router.push('/examReplay?rmid='+this.dataObj.rmid + '&rpid='+this.dataObj.rpid+'&num='+this.dataObj.num)
      }
    },

    nextTopic(){
      this.$router.push('/exam?rmid='+this.dataObj.rmid)
    },

    goBack() {
      var that = this;
      that.$router.go(-1);
      setTimeout(function(){
        window.location.reload();
      },100)
    },

    goAgain(){
      console.log(this.listData)
      delete this.listData.is_true;
      delete this.listData.utid;
      delete this.listData.ai_error_analysis;
      delete this.listData.teacher_comment;
      this.listData.status = 0;
      this.listDatais_comp_comment = 0;
      this.listData.topics.forEach(function(item,index){
        delete item.my_answer;
        delete item.lid;
        delete item.ai_comment;
        delete item.is_true;
        item.status = 0;
      })
    }
  },

  
};
</script>
<style scoped>
  .contentBox{
    width: 100%;
    height: 100%;
    padding: 101px 0 75px;
    background-color: #F8F9FC;
  }

  .title{
    color: #333333;
    font-size: 40px;
    display: block;
    font-weight: bold;
    text-align: center;
  }

  .btn-back{
    background-image: url(~@/assets/images/btn-bg1.png);
  }

  .detail{
    height: calc( 100% - 100px );
    
  }

  .detail-item{
    margin-top: 20px;
    padding: 0 80px;
    box-sizing: border-box;
    height: 100%;
  }

  .detail-txt{
    display: block;
    margin-top: 10px;
    font-size: 0;
    height: 100%;
  }

  .detail-txt .right,
  .detail-txt .left{
    width: 50%;
    display: inline-block;
    vertical-align: top;
    height: 100%;
    overflow-y: auto;
    overflow-x: hidden;
    box-sizing: border-box;
    padding: 10px 20px;
  }

  .detail-txt .left{
    background-color: #F7F9FA;
    border-radius: 6px;
  }

  .detail-txt .left .book-name{
    font-size: 24px;
    color: #000000;
    font-weight: bold;
    margin-bottom: 30px;
  }

  .detail-txt .left .book-name::before{
    content: '';
    width: 7px;
    height: 30px;
    background-color: #6098F2;
    display: inline-block;
    vertical-align: top;
    margin-right: 8px;
  }

  .detail-txt .left .txt{
    color: #000000;
    font-size: 22px;
    padding: 15px;
    box-sizing: border-box;
    white-space: pre-line;
  }

  .detail-txt .btn-sub{
    display: inline-block;
    vertical-align: top;
    margin: 0 10px 0 0;
  }

  .right-item{
    margin-bottom: 50px;
    display: block;
  }

  .right-item .topic-title{
    color: #333333;
    font-size: 24px;
    white-space: pre-line;
  }

  .right-item textarea{
    width: 100%;
    height: 300px;
    border-radius: 6px;
    border: solid 1px #333;
    margin-top: 10px;
    box-sizing: border-box;
    padding: 20px;
    font-size: 18px;
  }

  .btn-sub{
    font-size: 32px;
    color: #fff;
    padding: 15px 61px;
    border-radius: 60px;
    background-color: #6098F2;
    display: block;
    margin: 20px auto 0;
  }

  .answer{
    font-size: 0;
  }

  .answer .answer-title,
  .answer p{
    font-size: 24px;
    color: #333333;
    margin-top: 20px;
  }

  .answer .answer-title span{
    color: #E2231A;
  }

  .answer .answer-txt span{
    font-size: 18px;
    white-space: pre-line;
  }

  .answer .answer-title img,
  .answer .answer-title div{
    display: inline-block;
    vertical-align: top;
  }

  .aiBox{
    display: block;
    margin-bottom: 20px;
  }

  .ai-title{
    font-size: 24px;
    color: #333333;
  }

  .ai-title::before{
    content: '';
    width: 8px;
    height: 40px;
    background-color: #6098F2;
    display: inline-block;
    vertical-align: top;
    margin-right: 10px;
  }

  .ai-txt{
    font-size: 18px;
    color: #333;
    background-color: #EDEDED;
    border-radius: 6px;
    padding: 20px;
    box-sizing: border-box;
    margin-top: 20px;
    white-space: pre-line;
  }

  .btn-refresh{
    display: inline-block;
    vertical-align: top;
    padding: 5px 20px;
    border-radius: 6px;
    margin-left: 20px;
    background-color: #6098F2;
    color: #fff;
    font-size: 16px;
  }

  .answer-loading{
    width: 212px;
    height: 46px;
    display: block;
  }

  .mobileBox .detail{
    height: calc( 100% - .5rem );
  }

  .mobileBox .btn-back{
    height: .52rem;
    width: .52rem;
    background-size: .52rem .52rem;
  }

  .mobileBox .title{
    font-size: .3rem;
  }

  .mobileBox .detail-txt .left .txt{
    font-size: .18rem;
    padding: .2rem;
  }

  .mobileBox .right-item .topic-title{
    font-size: .2rem;
  }

  .mobileBox .btn-sub{
    font-size: .24rem;
  }

  @media screen and (max-width: 1600px){
    .contentBox{
      padding: 20px 0;
    }
  }
</style>



// WEBPACK FOOTER //
// src/identity/examTopic.vue